module.exports = "/_next/static/videos/adeptVideo-light-f429870e1645349395246126304abb7b.mp4";